import React, { useEffect, useState } from "react";
import DatabaseAdmin from "../Assets/database-admin.jpg";
import DatabaseAdminSupport from "../Assets/database-admin-support.png";
import DatabasePerformanceTuning from "../Assets/database-performance-tuning.png";
import DatabasePerformance from "../Assets/image-performance.png";
import DatabasePerformanceHigh from "../Assets/image-high.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {faCalendarCheck, faAngleUp, faDatabase} from "@fortawesome/free-solid-svg-icons";
import { useNavigate  } from "react-router-dom";
import "../Styles/Hero.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";

function Hero() {

    var settings = {
        dots: true,
        infinite: true,
        speed: 500,
        autoplay:true,
        arrows: true,
        slidesToShow: 1,
        slidesToScroll: 1,
    };

  const navigate = useNavigate();
  const [goUp, setGoUp] = useState(false);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleBookAppointmentClick = () => {
    navigate("/appointment");
  };

  useEffect(() => {
    const onPageScroll = () => {
      if (window.scrollY > 600) {
        setGoUp(true);
      } else {
        setGoUp(false);
      }
    };
    window.addEventListener("scroll", onPageScroll);

    return () => {
      window.removeEventListener("scroll", onPageScroll);
    };
  }, []);

  return (
    <div className="section-container">
      <div className="hero-section">
        <div className="text-section">
          <p className="text-headline"><span><FontAwesomeIcon icon={faDatabase} /></span> Database Administration & Monitoring</p>
          <h2 className="text-title">
              A Leader in Providing Database & Middleware Consulting Services
          </h2>
          <p className="text-descritpion">
              TechiesHub is well aware of the importance of proper data storage for businesses in any industry. Having a well-functioning database administration can drastically increase a company's potential. A properly managed DB can help reduce costs, improve business processes, and make informed decisions. With our services, you can create a solid foundation for data that can be used to grow your business.
          </p>
          <button
            className="text-appointment-btn"
            type="button"
            onClick={handleBookAppointmentClick}
          >
            <FontAwesomeIcon icon={faCalendarCheck} /> Request Consultations
          </button>
          <div className="text-stats">
            <div className="text-stats-container">
              <p>40+</p>
              <p>Customers</p>
            </div>

            <div className="text-stats-container">
              <p>20+</p>
              <p>Expert Specialists</p>
            </div>

            <div className="text-stats-container">
              <p>10+</p>
              <p>Years of Experience</p>
            </div>
          </div>
        </div>
          <div className="hero-image-section">
              <Slider {...settings}>
                  {/*<img className="hero-image1" src={ServerRoom} alt="Doctor"/>*/}
                  {/*<img className="hero-image1" src={DBA} alt="Doctor" />*/}
                  {/*<img className="hero-image1" src={DatabasePerformanceTuning} alt="Doctor" />*/}
                  <img className="hero-image1" src={DatabasePerformanceTuning} alt="Doctor" />
                  <img className="hero-image1" src={DatabaseAdminSupport} alt="Doctor" />
                  <img className="hero-image1" src={DatabaseAdmin} alt="Doctor" />
                  <img className="hero-image1" src={DatabasePerformance} alt="Doctor" />
                  <img className="hero-image1" src={DatabasePerformanceHigh} alt="Doctor" />
              </Slider>
          </div>


      </div>

      <div
        onClick={scrollToTop}
        className={`scroll-up ${goUp ? "show-scroll" : ""}`}
      >
        <FontAwesomeIcon icon={faAngleUp} />
      </div>
    </div>
  );
}

export default Hero;
